import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import functionAll from "./utils/functionAll";
import PageList from "./components/page/PageList";

Vue.component("page-list", PageList);
Vue.prototype.$functionAll = functionAll;

Vue.prototype.$axios = axios;
Vue.use(ElementUI, {
  size: "small",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
